import { validateEmail, validatePhoneNumber } from '../../core/helpers';
import fetchUserLists from './fetch-user-lists';

const share_url = '/apps/promo/invite-friends-and-family';
// const share_url = 'http://localhost:4466/v1/invite-friends-and-family';
let wishlist_id = 0;
let wishlist_items = [];

// https://developers.swym.it/docs/email-wishlist
let share_list_ready_checks = 0;
const shareListByEmail = async (wishlist_id = '', to_email, custom_note = '') => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof window._swat === 'undefined' && share_list_ready_checks < 5) {
        window.setTimeout(() => {
          share_list_ready_checks++;
          shareListByEmail();
        }, 1000);

        return;
      }

      if (wishlist_id === '') {
        const lists = await fetchUserLists();
        // console.log('lists', lists);
        const wishlist_item = _.find(lists, { lname: 'My Wishlist' });
        if (typeof wishlist_item === 'undefined') {
          console.log(`Customer's wishlist not found`);
          return;
        }

        wishlist_id = wishlist_item.lid;
      }

      // information required to send the email
      let customer_name = 'ASTR the Label';
      customer_name = (window.theme.customer.first_name === '') ? customer_name : window.theme.customer.first_name;
      customer_name = (window.theme.customer.last_name === '') ? customer_name : `${customer_name} ${window.theme.customer.last_name}`;
      const params = {
        toEmailId: to_email,
        fromName: customer_name,
        note: custom_note,
        lid: wishlist_id, // null when multiple list is not enabled
        cprops: {}, // custom props for the share, future usage
      };
      // console.log('params', params);

      // Success Callback.
      const onSuccess = (response) => {
        console.log('Successfully sent the wishlist contents via Email', response);
        resolve(true);
      };

      // Error Callback.
      const onError = (error) => {
        // Error is an xhrObject
        console.log('There was an Error Sending the email', error);
        reject(error);
      };

      // Send API 
      window._swat.sendListViaEmail(params, onSuccess, onError);
    } catch (e) {
      console.log(e);
    }
  });
};

// https://developers.swym.it/docs/share-via-link
let share_link_ready_checks = 0;
const shareListByLink = async (wishlist_id = '',) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (typeof window._swat === 'undefined' && share_link_ready_checks < 5) {
        window.setTimeout(() => {
          share_link_ready_checks++;
          shareListByLink();
        }, 1000);

        return;
      }

      if (wishlist_id === '') {
        const lists = await fetchUserLists();
        // console.log('lists', lists);
        const wishlist_item = _.find(lists, { lname: 'My Wishlist' });
        if (typeof wishlist_item === 'undefined') {
          console.log(`Customer's wishlist not found`);
          return;
        }

        wishlist_id = wishlist_item.lid;
      }

      // Success Callback.
      const onSuccess = (link, lid) => {
        console.log('Successfully Generated Link', link, lid);
        resolve(link);
      };

      // Error Callback.
      const onError = (error) => {
        // Error is an xhrObject
        console.log('Error while generating the link', error);
        reject(error);
      };

      // Send API 
      window._swat.generateSharedListURL(wishlist_id, onSuccess, onError);
    } catch (e) {
      console.log(e);
    }
  });
};

const submitFriendsFamilyForm = () => {
  return new Promise(async (resolve) => {
    try {
      const share_value = $('.share-wishlist-modal__step.active input').val();
      const share_type = $('.share-wishlist-modal__step.active[data-share-wishlist-step-email').length ? 'email' : 'sms';

      // This will make the wishlist public without having to make a backend request
      if (share_type === 'sms') {
        const share_link = await shareListByLink(wishlist_id);
        console.log('share_link', share_link);
      }

      $.ajax({
        url: `${share_url}${window.theme.customer.app_signature}`,
        dataType: 'json',
        type: 'post',
        data: {
          share_type,
          share_value,
          share_list_id: wishlist_id,
          share_customer_id: window.theme.customer.id,
          share_customer_email: window.theme.customer.email,
        },
        success: async (data) => {
          console.log('FF data', data);
          $('.share-wishlist-modal__step').removeClass('active');
          $('[data-share-wishlist-step-complete]').addClass('active');
  
          const promo_code = (typeof data === 'undefined' || data === null || typeof data.promo_code === 'undefined') ? '' : data.promo_code;

          // This will trigger a Klaviyo flow
          if (share_type === 'email') {
            const custom_note = (promo_code === '') ? wishlist_id : `${wishlist_id}|${promo_code}`;
            await shareListByEmail(wishlist_id, share_value, custom_note);
          }

          gtag('event', 'friends_family', {
            'step': 'email-sent',
          });
          
          resolve(true);
        },
        error: (XHR) => {
          console.log(XHR);
          $('.share-wishlist-modal__step.active .error').html('An error occured, please try later.').addClass('active');
          resolve(false);
        },
      });
    } catch (err) {
      console.log('Cannot submit the friends & family form', err);
      resolve(null);
    }
  });
};

let swym_ready_checks = 0;
const retrieveWishlist = () => {
  return new Promise(async (resolve, reject) => {
    if (typeof window._swat === 'undefined' && swym_ready_checks < 5) {
      window.setTimeout(() => {
        swym_ready_checks++;
        retrieveWishlist();
      }, 1000);

      return;
    }

    const lists = await fetchUserLists();
    const wishlist_item = _.find(lists, { lname: 'My Wishlist' });
    console.log('wishlist_item', wishlist_item);
    if (typeof wishlist_item !== 'undefined') {
      wishlist_id = wishlist_item.lid;
      wishlist_items = wishlist_item.listcontents;
      $('[data-open-share-wishlist-modal]').addClass('active');
    }

    if (wishlist_id === 0 || wishlist_items.length === 0) {
      $('[data-open-share-wishlist-modal]').removeClass('active').addClass('disabled');
      $('.share-wishlist__no-wishlist').addClass('active');
    }

    resolve(true);
  });
};

const initFriendFamilyShare = async () => {
  if (!$('.share-wishlist-section').length) {
    return;
  }

  $(document).on('click', '[data-open-share-wishlist-modal]', (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const $item = $(e.currentTarget);

    if ($item.hasClass('disabled')) {
      return;
    }

    $($item.data('modal')).modal({
      fadeDuration: 250,
      fadeDelay: 0.80,
    });

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      // [ADA]
      $('#share-wishlist-modal .close-modal').attr('role', 'button');
      $('#share-wishlist-modal .close-modal').trigger('focus');
      $('#share-wishlist-modal .close-modal').removeAttr('style');

      $('.share-wishlist-modal__step').removeClass('active');
      $('[data-share-wishlist-step-start]').addClass('active');

      $('#share-wishlist-modal input').removeClass('input-error');
      $('#share-wishlist-modal .error').removeClass('active');
    });
  });

  $(document).on('click', '[data-share-wishlist-by-email]', () => {
    $('.share-wishlist-modal__step').removeClass('active');
    $('[data-share-wishlist-step-email]').addClass('active');
  });
  
  $(document).on('click', '[data-share-wishlist-by-sms]', () => {
    $('.share-wishlist-modal__step').removeClass('active');
    $('[data-share-wishlist-step-sms]').addClass('active');
  });

  $(document).on('submit', `.share-wishlist-modal__form`, async (e) => {
    e.preventDefault();

    const $item = $(e.currentTarget);

    if ($item.find('#friendEmail').length) {
      if ($item.find('#friendEmail').val() === '' || !validateEmail($item.find('#friendEmail').val())) {
        $item.find('#friendEmail').addClass('input-error');
        $item.find('.error').text('Please add a correct email').addClass('active');
        return false;
      }

      // $item.trigger('submit');
      $('#share-wishlist-modal input').removeClass('input-error');
      $('#share-wishlist-modal .error').removeClass('active');

      $item.prop('disabled', true);
      $item.find('span').text('Please wait...');
      await submitFriendsFamilyForm();
      $item.prop('disabled', false);
      $item.find('span').text('Send Email');
      return true;
    }

    if ($item.find('#friendNumber').length) {
      if ($item.find('#friendNumber').val() === '' || !validatePhoneNumber($item.find('#friendNumber').val())) {
        $item.find('#friendNumber').addClass('input-error');
        $item.find('.error').text('Please add a correct US phone number').addClass('active');
        return false;
      }

      // $item.trigger('submit');
      $('#share-wishlist-modal input').removeClass('input-error');
      $('#share-wishlist-modal .error').removeClass('active');

      $item.prop('disabled', true);
      $item.find('span').text('Please wait...');
      await submitFriendsFamilyForm();
      $item.prop('disabled', false);
      $item.find('span').text('Send SMS');
      return true;
    }
  });

  retrieveWishlist();
};

export {
  initFriendFamilyShare,
};
